import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { SearchResult } from "../models/search-result.model";
import { LoadDocsModel } from "../models/load-docs.model";
import { BehaviorSubject } from "rxjs";
import { LoadCodeModel } from "../models/load-code.model";
import { LoadApptsModel } from "../models/load-appt.model";
import { ApptModel } from "../models/appt.model";
import { TimeClockModel } from "../models/time-clock.model";
import { CheckMailModel } from "../models/chek-mail.model";
import { EmployeeEmailModel } from "../models/employee-email.model";
import { ApptResourceModel } from "../models/appt-resource.model";
import { ApptTotalModel } from "../models/appt-total.model";
import { CurrentUserModel } from "../models/current-user.model";
import { ApplicationUserList } from "../models/application-user-list.model";
import { EmployeeSearchModel } from "../models/employee.model";
import { Subject } from "rxjs";


@Injectable({
    providedIn: "root"
})
export class UserService {

    private baseUrl: string = 'user';
    current_client_no: number = 0;
    // clinic: any = JSON.parse(localStorage['clinic']);  
    // userData: any = JSON.parse(localStorage['currentUser']);

    load_codes: LoadCodeModel[] = [];
    load_codes2: LoadCodeModel[] = [];
    lst_load_docs: LoadDocsModel[] = [];
    lst_load_docs2: LoadDocsModel[] = [];
    load_appts: LoadApptsModel[] = [];
    load_appts2: LoadApptsModel[] = [];
    times = []; // time array
    load_docs: LoadDocsModel = new LoadDocsModel('', '', 0, '', '', '', 0);
    load_docs2: LoadDocsModel = new LoadDocsModel('', '', 0, '', '', '', 0);
    appt: ApptModel = new ApptModel(0, 0, 0, '', '', '', '', '', '', '', false);
    user_email: EmployeeEmailModel = new EmployeeEmailModel('', '', '', '', '', false, false, '', '', '');
    appt2: ApptModel = new ApptModel(0, 0, 0, '', '', '', '', '', '', '', false);
    time_clock: TimeClockModel[] = [];
    time_clock_thisWeek: TimeClockModel[] = [];
    check_mails: CheckMailModel[] = [];
    user_mails: EmployeeEmailModel[] = [];
    time_clock_lastWeek: TimeClockModel[] = [];
    appt_resource: ApptResourceModel[] = [];
    appt_total: ApptTotalModel[] = [];
    apptDateSelected: string;
    emp_timeclock: TimeClockModel[] = [];
    clinic_timeclock: TimeClockModel[] = [];
    etc_dates:{datefrom:string,dateto:string} = {datefrom:'',dateto:''}
    application_user_list: ApplicationUserList[] = [];
    application_user_data = new ApplicationUserList(0, '', '', 0, '', 0, '',0,0,'');

    timeclock_param: {clinic_no:number, date_from: any,date_to: any}= {clinic_no:0, date_from: '',date_to: ''}; 
    emp_timeclock_param: EmployeeSearchModel= {employee_no:0,employee_name:'',username:'',role:0}

    //mailcount: {TotalMail:number, UrgentMailCount:number, ProtectedMailCount:number} = {TotalMail:0, UrgentMailCount:0, ProtectedMailCount:0};

    private messageGenericSource = new BehaviorSubject<boolean>(false);
    selectedGeneric = this.messageGenericSource.asObservable();

    constructor(
        private api: ApiService
    ) {

    }

    selectedGenericVar(message: boolean) {
        this.messageGenericSource.next(message)
    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }
    
    get clinic(): any {
        return JSON.parse(localStorage['clinic']);  
    }

    get empParam(): EmployeeSearchModel {
        return this.emp_timeclock_param;
    }

    private notify_GetMail = new Subject<void>();
    notify_GetMailObservable = this.notify_GetMail.asObservable(); 
    notify_GetMailFunction() { 
        this.notify_GetMail.next();
    }

    loadDocs() {

        let clinic_no = '';
        if (localStorage.currentUser && localStorage.token) {
            const currentUser: CurrentUserModel = JSON.parse(localStorage.currentUser);
            clinic_no = currentUser.clinic_no;
            this.load_docs.clinic_no = Number(clinic_no);
        }

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/loadDocs`, this.load_docs)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.lst_load_docs = res.data.map((element) => {
                            return new LoadDocsModel(element.dtpAppt, element.message, element.appt_resource_id, element.appt_resource_code, element.appt_resource_time_str, this.setBg(), element.appt_employee_no);
                        });
                        resolve(1);
                    } else {
                        this.lst_load_docs = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }


    loadDocs_Single() {
        console.log(this.load_docs2);
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/loadDocsSingle`, this.load_docs2)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        console.log(res.data)
                        this.lst_load_docs2 = res.data.map((element) => {
                            return new LoadDocsModel(element.dtpAppt, element.message, element.appt_resource_id, element.appt_resource_code, element.appt_resource_time_str, this.setBg(), element.appt_employee_no);
                        });
                        resolve(1);
                    } else {
                        this.lst_load_docs2 = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }
    

    setBg(): string {
        const randomColor = Math.floor(Math.random() * 16777215).toString(16);
        return `#${randomColor}`;
    }

    loadCode() {
        let promise = new Promise((resolve, reject) => {
            this.api.get(`${this.baseUrl}/loadCode`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.load_codes = res.data.map((element) => {
                            return new LoadCodeModel(element.appt_proc_id, element.appt_proc_name, element.appt_proc_code, element.appt_max);
                        });
                        resolve(1);
                    } else {
                        this.load_codes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    loadCode_Single() {
        let promise = new Promise((resolve, reject) => {
            this.api.get(`${this.baseUrl}/loadCode`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.load_codes2 = res.data.map((element) => {
                            return new LoadCodeModel(element.appt_proc_id, element.appt_proc_name, element.appt_proc_code, element.appt_max);
                        });
                        resolve(1);
                    } else {
                        this.load_codes2 = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateProcNo(dtpAppt: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get(`${this.baseUrl}/updateProcNo?dtpAppt=${dtpAppt}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    loadAppts(dtpAppt: string) {

        let clinic_no = '';
        if (localStorage.currentUser && localStorage.token) {
            const currentUser: CurrentUserModel = JSON.parse(localStorage.currentUser);
            clinic_no = currentUser.clinic_no;
            this.load_docs.clinic_no = Number(clinic_no);
        }

        let promise = new Promise((resolve, reject) => {
            this.api.get(`${this.baseUrl}/loadAppts?clinic_no=${clinic_no}&dtpAppt=${dtpAppt}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.load_appts = res.data.map((element) => {
                            return new LoadApptsModel(element.appointment_id, element.dropoff_time, element.dropoff_time_needed, element.doctor, element.doctor_time_needed, element.appointment_note, element.dropoff);
                        });
                        resolve(1);
                    } else {
                        this.load_appts = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    loadAppts_Single(dtpAppt: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get(`${this.baseUrl}/loadAppts?dtpAppt=${dtpAppt}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.load_appts2 = res.data.map((element) => {
                            return new LoadApptsModel(element.appointment_id, element.dropoff_time, element.dropoff_time_needed, element.doctor, element.doctor_time_needed, element.appointment_note, element.dropoff);
                        });
                        resolve(1);
                    } else {
                        this.load_appts2 = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupClientAppt() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupClientAppt`, this.appt)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getTimeClockByEmpNo(date_today: string, employee_no: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getTimeClockByEmpNo?date_today=${date_today}&employee_no=${employee_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.time_clock = res.data.map((element) => {
                            return new TimeClockModel(element.timeclock_seq, element.employee_no, element.employee_name, element.time_stamp, element.in_out, element.modifier);
                        });
                        resolve(1);
                    } else {
                        this.time_clock = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    insertTimeClock(employee_no: string, time_stamp: string, in_out: boolean, modifier: string, clinic_no: number, timeclock_seq:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/insertTimeClock?employee_no=${employee_no}&time_stamp=${time_stamp}&in_out=${in_out}&modifier=${modifier}&clinic_no=${clinic_no}&timeclock_seq=${timeclock_seq}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getTimeClockByWeek(weekstart: string,weekend: string,employee_no: string,week:string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getTimeClockByWeek?weekstart=${weekstart}&weekend=${weekend}&employee_no=${employee_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        if(week == 'last'){
                            this.time_clock_lastWeek = res.data.map((element) => { 
                                return new TimeClockModel(element.timeclock_seq,element.employee_no, element.employee_name, element.time_stamp, element.in_out,element.modifier);
                            });
                        }else if(week == 'this'){
                            this.time_clock_thisWeek = res.data.map((element) => {
                                return new TimeClockModel(element.timeclock_seq,element.employee_no, element.employee_name, element.time_stamp, element.in_out,element.modifier);
                            });
                        }
                        resolve(1);
                    } else {
                        if(week == 'last'){
                            this.time_clock_lastWeek = [];
                        }
                        else if(week == 'this'){
                            this.time_clock_thisWeek = [];
                        }
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getEmpNoByEmpPass(employeePassword: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/getEmpNoBYEmpPass?employee_password=${employeePassword}`)
                .subscribe((res: string) => {
                    resolve(res);
                }, (error) => {
                    reject(error);
                });
        });
    }

    checkMail(user_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<CheckMailModel>(`${this.baseUrl}/checkMail?user_no=${user_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.check_mails.push(...res.data.map((element) => {
                            return new CheckMailModel(element.urgent, element.protected_);
                        }));
                        resolve(1);
                    } else {
                        this.check_mails = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getEmployeeEmail(user_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<CheckMailModel>(`${this.baseUrl}/getEmployeeEmail?user_no=${user_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.user_mails = [];
                        this.user_mails.push(...res.data.map((element) => {
                            return new EmployeeEmailModel(element.mail_sequence, element.employee_initial, element.mail_date, element.subject, element.message, element.urgent, element.protected_, element.employee_to, '', '');
                        }));
                        resolve(1);
                    } else {
                        this.user_mails = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupEmailNote() {        
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupEmailNote`, this.user_email)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupEmployeeEmail() {        
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupEmployeeEmail`, this.user_email)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteEmployeeEmail() {        
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteEmployeeEmail`, this.user_email)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getAppts(dteBeginDate: any, dteEndDate: any, clinic_no?: number) {
        const effectiveClinic = clinic_no ?? this.userData.clinic_no;
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getAppts?dteBeginDate=${dteBeginDate}&dteEndDate=${dteEndDate}&clinic_no=${effectiveClinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        console.log(res)
                        this.appt_resource = res.data.getAppts_1.map((element) => {
                            return new ApptResourceModel(element.appt_resource_code,element.appt_resource_date, element.appt_resource_time_str);
                        });
                        resolve(1);
                    } else {
                        this.appt_resource = [];
                        resolve(0);
                    }
                }); 
        });
        return promise;
    }  

    getTotalApptByMonth(dteBeginDate: any,dteEndDate: any,clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getTotalApptByMonth?dteBeginDate=${dteBeginDate}&dteEndDate=${dteEndDate}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {  
                        this.appt_total = res.data.map((element) => {
                            return new ApptTotalModel(element.appt_total,element.appt_resource_date, element.appt_resource_code);
                        });
                        resolve(1);
                    } else {
                        this.appt_total = [];
                        resolve(0);
                    }
                }); 
        });
        return promise;
    }  

    GetClinicTimeClockByDate(wfor: any) { 
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicTimeClockByDate?employee_no=${this.emp_timeclock_param.employee_no}&clinic_no=${this.timeclock_param.clinic_no}&date_from=${this.timeclock_param.date_from}&date_to=${this.timeclock_param.date_to}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {  
                        if(wfor == 'employee'){
                            this.emp_timeclock = res.data.map((element) => {
                                return new TimeClockModel(element.timeclock_seq,element.employee_no, element.employee_name, element.time_stamp, element.in_out,element.modifier); 
                            });
                        }
                        else if(wfor == 'clinic'){
                            this.clinic_timeclock = res.data.map((element) => {
                                return new TimeClockModel(element.timeclock_seq,element.employee_no, element.employee_name, element.time_stamp, element.in_out,element.modifier); 
                            });
                        } 

                        resolve(1);
                    } else {
                        this.emp_timeclock = [];
                        this.clinic_timeclock = [];
                        resolve(0);
                    }
                }); 
        });
        return promise;
    }   
    
    GetEmpByEmpPass(employeePassword: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetEmpByEmpPass?employee_password=${employeePassword}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
    }

    getEmpByEmpCreds(username:string ,employeePassword: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getEmpByEmpCreds?username=${username}&employee_password=${employeePassword}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
    } 
 
    EmpTimeClockRPT: {employee_no:number,clock_in_time:string,clock_out_time:string,duration_hours:number,remarks:string}[]= [];
    EmpRemarksRPT: {employee_no:number,remarks:string}[]= [];
 
    CreateEmpTimeClockRpt(){
        this.EmpTimeClockRPT = [];
        for (let i = 0; i < this.emp_timeclock.length - 1; i++) {
            const currentRecord = this.emp_timeclock[i];
            const nextRecord = this.emp_timeclock[i + 1];
    
            if (currentRecord.in_out == true && nextRecord.in_out == true) {
                this.EmpTimeClockRPT.push({
                    employee_no: currentRecord.employee_no,
                    clock_in_time: currentRecord.time_stamp,
                    clock_out_time: '',
                    duration_hours: 0,
                    remarks: 'No Time Out'
                });
            }
            else if(currentRecord.in_out == true && nextRecord.in_out == false && currentRecord.employee_no == nextRecord.employee_no){
                let remarks = '';
                let sduration = this.calculateDurationHours(currentRecord.time_stamp, nextRecord.time_stamp) 

                this.EmpTimeClockRPT.push({
                    employee_no: currentRecord.employee_no,
                    clock_in_time: currentRecord.time_stamp,
                    clock_out_time: nextRecord.time_stamp,
                    duration_hours: sduration,
                    remarks: remarks
                });
            }

        } 

        this.CreateEmpRemarksRpt()
    }

    CreateEmpRemarksRpt(){
        this.EmpRemarksRPT = [];

        this.EmpRemarksRPT.push({employee_no: 0 ,remarks: this.etc_dates.datefrom  + ' to ' + this.etc_dates.dateto});

        const weeklyTotalDuration: { employee_no: number, week:string, duration: number }[] = [];
    
        for (const entry of this.EmpTimeClockRPT) {
            const clockInTime = new Date(entry.clock_in_time);
            const weekNumber = this.getISOWeek(clockInTime);
    
            // Calculate the start and end dates of the week
            const startDate = new Date(clockInTime);
            startDate.setDate(startDate.getDate() - startDate.getDay()); // Start of the week (Sunday)
            const endDate = new Date(startDate);
            endDate.setDate(endDate.getDate() + 6); // End of the week (Saturday)
    
            // Generate the day range string
            const dayRange = `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
    
            // Create the week string
            const week = `${weekNumber}-${dayRange}`;
    
            // Check if there's already an entry for the week
            const existingEntryIndex = weeklyTotalDuration.findIndex(item => item.employee_no === entry.employee_no && item.week === week);
    
            // If an entry already exists, update the duration
            if (existingEntryIndex !== -1) {
                weeklyTotalDuration[existingEntryIndex].duration += entry.duration_hours;
            } else {
                // Otherwise, create a new entry
                weeklyTotalDuration.push({
                    employee_no: entry.employee_no,
                    week: week,
                    duration: entry.duration_hours
                });
            }
        }  
 
        const totalsPerEmployee: { employee_no: number, totalHrsWork: number, totalOvertime: number, totalRegTime: number }[] = [];
    
        weeklyTotalDuration.forEach((item) => { 
          const existingEntryIndex = totalsPerEmployee.findIndex(entry => entry.employee_no === item.employee_no);

            // If an entry already exists, update the totals
            if (existingEntryIndex !== -1) {
                totalsPerEmployee[existingEntryIndex].totalHrsWork += parseFloat(item.duration.toFixed(2));
                totalsPerEmployee[existingEntryIndex].totalOvertime += item.duration > 40 ? item.duration - 40 : 0;
                totalsPerEmployee[existingEntryIndex].totalRegTime += item.duration <= 40 ? item.duration : 40;
            } else {
                // Otherwise, create a new entry
                totalsPerEmployee.push({
                    employee_no: item.employee_no,
                    totalHrsWork: parseFloat(item.duration.toFixed(2)),
                    totalOvertime: item.duration > 40 ? item.duration - 40 : 0,
                    totalRegTime: item.duration <= 40 ? item.duration : 40
                });
            }

          if(item.duration > 40){
            this.EmpRemarksRPT.push({
              employee_no: item.employee_no, 
              remarks: 'Time worked during ' + item.week + ' : 40 hours 00 minutes \r\n Over Time : ' +  this.formatHrsAndMins(item.duration - 40)
            })
          } 
        })

        totalsPerEmployee.forEach((item) => {
            if(item.totalOvertime != 0){
                this.EmpRemarksRPT.push({
                  employee_no: item.employee_no, 
                  remarks: 'Total Hours Worked : ' + this.formatHrsAndMins(item.totalHrsWork) + ' \r\nTotal Regular Time : ' + this.formatHrsAndMins(item.totalRegTime) + ' \r\nTotal Overtime : ' + this.formatHrsAndMins(item.totalOvertime)
                })
              }
              else{
                this.EmpRemarksRPT.push({
                  employee_no: item.employee_no, 
                  remarks: 'Total Hours Worked : ' + this.formatHrsAndMins(item.totalHrsWork)
                })
              }
        }) 

        
    }
     
    getISOWeek(date: Date): number {
        const onejan = new Date(date.getFullYear(), 0, 1);
        const millisecsInDay = 86400000; // 1000 * 60 * 60 * 24
        return Math.ceil((((date.getTime() - onejan.getTime()) / millisecsInDay) + onejan.getDay() + 1) / 7);
    }

    calculateDurationHours(startTime: string, endTime: string): number {
        // Calculate duration in hours (assuming startTime and endTime are in valid date-time format)
        const start = new Date(startTime);
        const end = new Date(endTime);
        const durationMs = end.getTime() - start.getTime();
        return durationMs / (1000 * 60 * 60); // Convert milliseconds to hours
    }

    formatHrsAndMins(decimalHours: number): string {
        // Extract the whole hours
        const hours = Math.floor(decimalHours);
    
        // Calculate the remaining minutes
        const decimalMinutes = (decimalHours - hours) * 60;
        const minutes = Math.round(decimalMinutes);
    
        // Construct the formatted string
        let formattedString = '';
        if (hours > 0) {
            formattedString += hours + 'hrs';
        }
        if (minutes > 0) {
            formattedString += ' ' + minutes + 'mins';
        }
    
        return formattedString;
    }









    SetupClinicTimeClockRpt() {
        const requestBody = {
            id: this.clinic[0].clinic_no,
            jsonstring: JSON.stringify(this.EmpTimeClockRPT),
            remarks: JSON.stringify(this.EmpRemarksRPT), 
        }; 

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupClinicTimeClockRpt`, requestBody)
              .subscribe((res: any) => { 
                if (res && res.data) {
                  resolve(1);
                } else {
                  resolve(0);
                }
              }, (error) => {
                reject(error);
              });
        });
        
        return promise;
    }

    deleteTimeClockItem(timeclock_seq: number) {        
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteTimeClockItem?timeclock_seq=${timeclock_seq}`, )
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetApplicationUserByTenant(tenant_no: number) {
        this.application_user_list = [];
        let promise = new Promise((resolve, reject) => {
            this.api.get<ApplicationUserList>(`${this.baseUrl}/GetApplicationUserByTenant?tenant_no=${tenant_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.application_user_list.push(...res.data.map((element) => {
                            return new ApplicationUserList(element.Id,element.UserName,element.Email,element.clinic_no,element.clinic_name,element.RoleId,element.RoleName,element.AppUserRoleId,element.tenant_no,element.tenant_name);
                        }));
                        resolve(1);
                    } else {
                        this.application_user_list = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetApplicationUser() {
        this.application_user_list = [];
        let promise = new Promise((resolve, reject) => {
            this.api.get<ApplicationUserList>(`${this.baseUrl}/GetApplicationUser`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.application_user_list.push(...res.data.map((element) => {
                            return new ApplicationUserList(element.Id,element.UserName,element.Email,element.clinic_no,element.clinic_name,element.RoleId,element.RoleName,element.AppUserRoleId,element.tenant_no,element.tenant_name);
                        }));
                        console.log(this.application_user_list)
                        resolve(1);
                    } else {
                        this.application_user_list = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupApplicationUserRole( Id:number, UserId:number, RoleId:number, Clinic_no:number, Tenant_no:number, Type:number){        
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupApplicationUserRole?Id=${Id}&UserId=${UserId}&RoleId=${RoleId}&Clinic_no=${Clinic_no}&Tenant_no=${Tenant_no}&Type=${Type}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    // GetMailCount(employee_no: number): Promise<number> {
    //     return new Promise((resolve, reject) => {
    //         this.api.get<number>(`${this.baseUrl}/GetMailCount?employee_no=${employee_no}`)
    //             .subscribe((res: any) => {
    //                 this.mailcount.TotalMail = res.data.TotalMail;
    //                 this.mailcount.UrgentMailCount = res.data.UrgentMailCount;
    //                 this.mailcount.ProtectedMailCount = res.data.ProtectedMailCount;
    //                 console.log('run here user serv');
    //                 resolve(1);
    //             }, (error) => {
    //                 reject(error);
    //             });
    //     });
    // }






}